import styled from 'shared/theme'

export const ArcRows = styled.div`
    display: grid;
    grid-row-gap: 0.5rem;
`
